import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect, useCallback, useRef } from 'react';
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import 'antd/dist/reset.css';

const { RangePicker } = DatePicker;

function MatchManagement() {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const [shouldMaintainFocus, setShouldMaintainFocus] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [dateRange, setDateRange] = useState(null);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const searchInputRef = useRef(null);

    const fetchMatches = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            if (searchTerm.trim()) {
                params.append('search', searchTerm.trim());
            }


            if (activeTab === 'matched') {
                params.append('status', '1');
            } else if (activeTab === 'declined') {
                params.append('status', '2');
            } else if (activeTab === 'pending') {
                params.append('status', '0');
            }


            if (dateRange && dateRange[0] && dateRange[1]) {
                const formatDate = (date) => {
                    return date.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
                };
                const dateRangeArray = [formatDate(dateRange[0]), formatDate(dateRange[1])];
                params.append('date_range', JSON.stringify(dateRangeArray));
            }

            params.append('page', currentPage.toString());
            params.append('limit', limit.toString());

            const url = `match-management?${params.toString()}`;
            const response = await getApi(url);

            if (response?.statusCode === 200) {
                setMatches(response.data || []);
            } else {
                setError(response?.message || 'Failed to fetch matches');
                console.error('Failed to fetch matches:', response?.message);
            }
        } catch (error) {
            setError('Error fetching matches. Please try again.');
            console.error('Error fetching matches:', error);
        } finally {
            setLoading(false);
        }
    }, [searchTerm, currentPage, limit, activeTab, dateRange]);

    useEffect(() => {

        const timeoutId = setTimeout(() => {
            fetchMatches();
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchTerm, currentPage, activeTab, dateRange, fetchMatches]);


    useEffect(() => {
        if ((shouldMaintainFocus || isTyping) && !loading && searchInputRef.current) {

            setTimeout(() => {
                if (searchInputRef.current) {
                    searchInputRef.current.focus();

                    const length = searchInputRef.current.value.length;
                    searchInputRef.current.setSelectionRange(length, length);
                }
            }, 0);
            setShouldMaintainFocus(false);
        }
    }, [loading, shouldMaintainFocus, isTyping]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
        setShouldMaintainFocus(true);
        setIsTyping(true);


        setTimeout(() => {
            setIsTyping(false);
        }, 1000);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
    };

    const getFilteredMatches = () => {

        return matches;
    };

    const filteredMatches = getFilteredMatches();

    const formatDate = (dateValue) => {
        if (!dateValue) return '-';

        // Handle both timestamp (number) and ISO string formats
        let date;
        if (typeof dateValue === 'number') {
            // If it's a timestamp, convert it to Date
            date = new Date(dateValue);
        } else {
            // If it's a string, parse it normally
            date = new Date(dateValue);
        }

        return date.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const getStatusBadge = (actionType) => {

        if (actionType === 0) {
            return (
                <button className="btn btn-status btn-status-warning">
                    <img src={window.getPublicUrl('/images/dot.svg')} alt="Status" /> Pending
                </button>
            );
        } else if (actionType === 1) {
            return (
                <button className="btn btn-status btn-status-primary">
                    <img src={window.getPublicUrl('/images/dot.svg')} alt="Status" /> Accepted
                </button>
            );
        } else if (actionType === 2) {
            return (
                <button className="btn btn-status btn-status-danger">
                    <img src={window.getPublicUrl('/images/dot.svg')} alt="Status" /> Rejected
                </button>
            );
        }

        return (
            <button className="btn btn-status btn-status-secondary">
                <img src={window.getPublicUrl('/images/dot.svg')} alt="Status" /> Unknown
            </button>
        );
    };

    if (loading) {
        return (
            <div className="right-section">
                <div className="loader-overlay">
                    <span className="loader"></span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="right-section">
                <div className="customer-top">
                    <div className="customer-top-left">
                        <ul>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'all' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabChange('all');
                                    }}
                                >
                                    All
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'matched' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabChange('matched');
                                    }}
                                >
                                    Matched
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'declined' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabChange('declined');
                                    }}
                                >
                                    Declined
                                </a>
                            </li>

                        </ul>
                    </div>
                    <div className="customer-top-right">
                        {/* <div className='form-control'>
                            <div className='plan-select'>
                                <p>Chat Unlocked?</p>
                                <div className=''>
                                    <label class="custom-switch">
                                        <input type="checkbox" />
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                         <div className='form-control'>
                            <div className='plan-select'>
                                <p>Call scheduled?</p>
                                <div className=''>
                                    <label class="custom-switch">
                                        <input type="checkbox" />
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div> */}



                        <div className='date-range-picker'>
                            <RangePicker
                                key={`dateRange-${isDatePickerOpen}`}
                                onChange={(dates) => {
                                    if (dates && dates[0] && dates[1]) {
                                        setDateRange(dates);
                                    } else {
                                        setDateRange(null);
                                    }
                                }}
                                separator={'-'}
                                value={dateRange}
                                allowClear={false}
                                placeholder={['Start date', 'End date']}
                                disabledDate={(current) => {
                                    if (current && current < dayjs().startOf('day')) {
                                        return true;
                                    }

                                    if (dateRange && dateRange[0]) {
                                        const maxEndDate = dateRange[0].add(90, 'day');
                                        if (current && current > maxEndDate) {
                                            return true;
                                        }
                                    }

                                    return false;
                                }}
                                style={{
                                    width: '200px',
                                    border: '1px solid #D9D9D9',
                                    borderRadius: '8px',
                                    padding: '7px 12px',
                                    height: '44px'
                                }}
                                format="MMM DD, YYYY"
                                open={isDatePickerOpen}
                                onOpenChange={(open) => {
                                    setIsDatePickerOpen(open);
                                }}
                            />
                        </div>



                        <input
                            ref={searchInputRef}
                            type="text"
                            className="search-input"
                            placeholder="Search by name / email / phone"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onFocus={() => setShouldMaintainFocus(true)}
                            onBlur={() => {
                                // Only clear focus if not actively typing
                                if (!isTyping) {
                                    setShouldMaintainFocus(false);
                                }
                            }}
                            key={`search-${searchTerm.length}`}
                        />
                    </div>
                </div>

                <div className="customer-tablle-main">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="uid">Match ID</th>
                                <th className="name">User A</th>
                                <th className="name">User B</th>
                                <th className="date">Match Date</th>
                                <th className="status">Status</th>
                                <th className="verified">Call</th>
                                <th className="action">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMatches.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        No matches found
                                    </td>
                                </tr>
                            ) : (
                                filteredMatches.map((match) => (
                                    <tr key={match.id}>
                                        <td className="uid">{match.id}</td>
                                        <td className="name">
                                            <div className="table-mails">
                                               <span className="profile-img">
      <img
        src={
          match.user?.User_Images && match.user.User_Images.length > 0
            ? match.user.User_Images[0].image
            : window.getPublicUrl("/images/john.svg") // fallback dummy image
        }
        alt="User A"
      />
    </span>
                                                <div>
                                                    <h3>{match.user?.full_name || 'N/A'}</h3>
                                                    <p>{match.user?.email || match.user?.phone_number || 'N/A'}</p>
                                                    {/* <p className="phone-number">{match.user?.phone_number || 'N/A'}</p> */}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="name">
                                            <div className="table-mails">
                                                 <span className="profile-img">
      <img
        src={
          match.otherUser?.User_Images && match.otherUser.User_Images.length > 0
            ? match.otherUser.User_Images[0].image
            : window.getPublicUrl("/images/profile-two.svg") // fallback dummy image
        }
        alt="User B"
      />
    </span>
                                                <div>
                                                    <h3>{match.otherUser?.full_name || 'N/A'}</h3>
                                                    <p>{match.otherUser?.email || match.otherUser?.phone_number || 'N/A'}</p>
                                                    {/* <p className="phone-number">{match.otherUser?.phone_number || 'N/A'}</p> */}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="date">{formatDate(match.createdAt)}</td>
                                        <td className="status">
                                            {getStatusBadge(match.status)}
                                        </td>
                                        <td className="verified">1</td>
                                        <td className="action">
                                            <div className="view-image">
                                                <Link to={`/admin/viewMatchManagement/${match.id}`}>
                                                    <button className="btn">
                                                        <img src={window.getPublicUrl('/images/view.svg')} alt="View" />
                                                    </button>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default MatchManagement;